import { render } from "./AppTop.vue?vue&type=template&id=f4520f8c"
import script from "./AppTop.vue?vue&type=script&lang=js"
export * from "./AppTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__